import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import ModalBloqueio from "react-modal";
import ModalAviso from "react-modal";
import ModalMochila from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpAviso from "../../../componente/popup/index.jsx";
import PopUpBloqueio from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import AWS from 'aws-sdk';

function CadColaborador() {
  const { DateTime } = require("luxon");

  const [listaSetor, setlistaSetor] = useState([]);
  const [listaFuncao, setlistaFuncao] = useState([]);
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodcolaborador, setedtcodcolaborador] = useState(0);
  const [edtcodsetor, setedtcodsetor] = useState(0);
  const [edtcodfuncao, setedtcodfuncao] = useState(0);
  const [edtnome, setedtnome] = useState("");
  const [edtsupervisor, setedtsupervisor] = useState("");
  const [edtusuario, setedtusuario] = useState("");
  const [edtsenha, setedtsenha] = useState("");
  const [edtativo, setedtativo] = useState("");
  const [edttipoacesso, setedttipoacesso] = useState("");
  const [edtfoto, setedtfoto] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  //campos de bloqueio
  const [isOpenBloqueio, setIsOpenBloqueio] = useState(false);
  const [listabloqueio, setlistabloqueio] = useState([]);
  const [showformbloqueio, setshowformbloqueio] = useState(false);
  const [edtcodbloqueio, setedtcodbloqueio] = useState(0);
  const [edtdtlancamento, setedtdtlancamento] = useState("");
  const [edtmotivo, setedtmotivo] = useState("");
  const [edtdtvencimento, setedtdtvencimento] = useState("");

  //campos de aviso
  const [isOpenAviso, setIsOpenAviso] = useState(false);
  const [listaaviso, setlistaaviso] = useState([]);
  const [showformaviso, setshowformaviso] = useState(false);
  const [edtcodaviso, setedtcodaviso] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");

  //campos mochila
  const [showformmochila, setshowformmochila] = useState(false);
  const [CodInventario, setCodInventario] = useState(0);
  const [SaldoCoin, setSaldoCoin] = useState(0);
  const [SaldoReal, setSaldoReal] = useState(0);
  const [listabeneficio, setlistabeneficio] = useState([]);
  const [listaitens, setlistaitens] = useState([]);

  // Configuração da AWS
  AWS.config.update({
    accessKeyId: 'AKIAY3NQW3W4IZFQLWC5', // AccountName
    secretAccessKey: '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', // AccountKey
    region: 'us-east-1', // Certifique-se de que esta é a região correta do bucket S3
  });

  const s3 = new AWS.S3();
  const bucketName = 'isolution'; // BucketName

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const params = {
      Bucket: bucketName,
      Key: `iGame/ImagensProfissional/${edtnome}_${file.name}`, // ObjectName + Nome do Arquivo
      Body: file,
      ContentType: file.type,
      ACL: 'public-read', // Permissão para tornar o arquivo acessível publicamente
    };

    try {
      // Upload para o S3
      const { Location } = await s3.upload(params).promise();
      setedtfoto(Location); // Armazena o link da imagem no estado edtfoto
      alert("Upload realizado com sucesso!");
    } catch (error) {
      console.error('Erro no upload:', error);
      alert("Erro ao realizar o upload.");
    }
  };

  const handleOpenAviso = (cad) => {
    setedtcodaviso(cad.codaviso);
    setIsOpenAviso(true);
  };

  const handleConfirmaAviso = () => {
    setIsOpenAviso(false);
    ExcluirAviso();
  };

  const handleCloseAviso = () => {
    setIsOpenAviso(false);
  };

  const handleOpenBloqueio = (cad) => {
    setedtcodbloqueio(cad.codbloqueio);
    setIsOpenBloqueio(true);
  };

  const handleConfirmaBloqueio = () => {
    setIsOpenBloqueio(false);
    ExcluirBloqueio();
  };

  const handleCloseBloqueio = () => {
    setIsOpenBloqueio(false);
  };

  const handleOpen = (cad) => {
    setedtcodcolaborador(cad.codcolaborador);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListaSetor() {
    api
      .get("v1/cadastro/setor", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaSetor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListaFuncao() {
    api
      .get("v1/cadastro/funcao", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaFuncao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaborador() {
    api
      .get("v1/cadastro/colaborador", {
        params: {
          busca: abusca,
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarColaborador();
    },
    [showform, abusca, selectedCompany]
  );

  function ListarAviso() {
    api
      .get("/v1/cadastro/colaborador/aviso", {
        params: {
          busca: "",
          codcolaborador: edtcodcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setedtdescricao("");

        setlistaaviso(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });

    setshowformaviso(true);
  }

  function ListarBloqueio() {
    api
      .get("v1/cadastro/colaborador/bloqueio", {
        params: {
          busca: "",
          codcolaborador: edtcodcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        const dt = new Date();
        const date =
          dt.getFullYear() +
          "-" +
          (dt.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          dt.getDate().toString().padStart(2, "0");
        let time =
          dt.getHours().toString().padStart(2, "0") +
          ":" +
          dt.getMinutes().toString().padStart(2, "0") +
          ":" +
          dt.getSeconds().toString().padStart(2, "0");;
        let dtcadastro = date + "T" + time;

        setedtdtlancamento(dtcadastro);
        setedtmotivo("");
        setedtdtvencimento(dtcadastro);

        setlistabloqueio(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });

    setshowformbloqueio(true);
  }

  function ListarMochila() {
    api
      .get("/v1/cadastro/colaborador/mochilacolaborador", {
        params: {
          busca: "",
          codcolaborador: edtcodcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setCodInventario(response.data.codinventario);
        setSaldoCoin(response.data.saldocoin);
        setSaldoReal(response.data.saldoreal);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });

    api
      .get("/v1/cadastro/colaborador/mochilacolaborador/itensmochila", {
        params: {
          busca: "",
          codinventario: CodInventario,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaitens(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });

    api
      .get("/v1/cadastro/colaborador/colaboradortitulo", {
        params: {
          busca: "",
          codcolaborador: edtcodcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistabeneficio(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });

    setshowformmochila(true);
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/colaborador",
        {
          codfuncao: edtcodfuncao,
          codsetor: edtcodsetor,
          nome: edtnome,
          supervisor: edtsupervisor,
          usuario: edtusuario,
          senha: edtsenha,
          codassinante,
          codempresa: selectedCompany,
          tipoacesso: edttipoacesso,
          ativo: edtativo,
          excluido: "N",
          foto: edtfoto,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaborador();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarAviso() {
    api
      .post(
        "/v1/cadastro/colaborador/aviso",
        {
          descricao: edtdescricao,
          visualizado: 'N',
          codcolaborador: edtcodcolaborador,
          codassinante,
          codempresa: selectedCompany,
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarAviso();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarBloqueio() {
    api
      .post(
        "v1/cadastro/colaborador/bloqueio",
        {
          dtlancamento: edtdtlancamento,
          motivo: edtmotivo,
          dtvencimento: edtdtvencimento,
          codcolaborador: edtcodcolaborador,
          codassinante,
          codempresa: selectedCompany,
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarBloqueio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/colaborador",
        {
          codcolaborador: edtcodcolaborador,
          codsetor: edtcodsetor,
          codfuncao: edtcodfuncao,
          nome: edtnome,
          supervisor: edtsupervisor,
          usuario: edtusuario,
          senha: edtsenha,
          ativo: edtativo,
          tipoacesso: edttipoacesso,
          foto: edtfoto,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarColaborador();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/colaborador", {
        params: {
          codcolaborador: edtcodcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarColaborador();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirAviso() {
    api
      .delete("v1/cadastro/colaborador/aviso", {
        params: {
          codaviso: edtcodaviso,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarAviso();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirBloqueio() {
    api
      .delete("v1/cadastro/colaborador/bloqueio", {
        params: {
          codbloqueio: edtcodbloqueio,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarBloqueio();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function closeModalBloqueio() {
    setshowformbloqueio(false);
  }

  function closeModalAviso() {
    setshowformaviso(false);
  }

  function closeModalMochila() {
    setshowformmochila(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodcolaborador(0);
    setedtcodsetor(0);
    setedtcodfuncao(0);
    setedtnome("");
    setedtsupervisor("N");
    setedtusuario("");
    setedtsenha("");
    setedtativo("S");
    setedttipoacesso("A");
    setedtfoto("");

    ListaFuncao();
    ListaSetor();
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodcolaborador(cad.codcolaborador);
    setedtcodsetor(cad.codsetor);
    setedtcodfuncao(cad.codfuncao);
    setedtnome(cad.nome);
    setedtsupervisor(cad.supervisor);
    setedtusuario(cad.usuario);
    setedtsenha(cad.senha);
    setedtativo(cad.ativo);
    setedttipoacesso(cad.tipoacesso);
    setedtfoto(cad.fotoperfil);

    ListaFuncao();
    ListaSetor();
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>

              <PopUpAviso isOpen={isOpenAviso} onClose={handleCloseAviso}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse aviso?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaAviso}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseAviso}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpAviso>

              <PopUpBloqueio isOpen={isOpenBloqueio} onClose={handleCloseBloqueio}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse bloqueio?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirmaBloqueio}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloseBloqueio}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUpBloqueio>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content modal-xl"
            >
              <div className="container-fluid h-100">
                <div className="modal-header">
                  <h2>Novo Cadastro</h2>
                  <button type="button" className="btn-close" onClick={closeModal}></button>
                </div>

                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="col-sm-6">
                        <label htmlFor="nome" className="form-label">
                          Nome
                        </label>
                        <input
                          type="text"
                          id="nome"
                          className="form-control"
                          placeholder="Nome"
                          value={edtnome}
                          onChange={(e) => setedtnome(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="supervisor" className="form-label">
                          Gestor
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="supervisor"
                            type="radio"
                            name="supervisor"
                            value="S"
                            onChange={(e) => setedtsupervisor(e.target.value)}
                            checked={edtsupervisor === "S"}
                          />
                          <label className="form-check-label">Sim</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="supervisor"
                            value="N"
                            onChange={(e) => setedtsupervisor(e.target.value)}
                            checked={edtsupervisor === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <label htmlFor="usuario" className="form-label">
                          Usuário
                        </label>
                        <input
                          type="text"
                          id="usuario"
                          className="form-control"
                          placeholder="Usuário"
                          value={edtusuario}
                          onChange={(e) => setedtusuario(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-6">
                        <label htmlFor="senha" className="form-label">
                          Senha
                        </label>
                        <input
                          type="password"
                          id="senha"
                          className="form-control"
                          placeholder="Senha"
                          value={edtsenha}
                          onChange={(e) => setedtsenha(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3">
                        <label htmlFor="setor" className="form-label">
                          Setor
                        </label>
                        <select
                          className="form-select"
                          id="setor"
                          value={edtcodsetor}
                          onChange={(e) => setedtcodsetor(e.target.value)}
                        >
                          <option value="0">Escolha o setor</option>
                          {listaSetor.map(function (set) {
                            return (
                              <option
                                key={set.codsetor}
                                value={set.codsetor}
                              >
                                {set.descricao}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="funcao" className="form-label">
                          Função
                        </label>
                        <select
                          className="form-select"
                          id="funcao"
                          value={edtcodfuncao}
                          onChange={(e) => setedtcodfuncao(e.target.value)}
                        >
                          <option value="0">Escolha a função</option>
                          {listaFuncao.map(function (fun) {
                            return (
                              <option
                                key={fun.codfuncao}
                                value={fun.codfuncao}
                              >
                                {fun.descricao}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="ativo1"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label className="form-check-label">Sim</label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div>
                          <label htmlFor="tipoacesso" className="form-label">
                            Tipo de Acesso
                          </label>
                          <br />
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              id="tipoacesso"
                              type="radio"
                              name="tipoacesso"
                              value="A"
                              onChange={(e) => setedttipoacesso(e.target.value)}
                              checked={edttipoacesso === "A"}
                            />
                            <label className="form-check-label">App</label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoacesso"
                              value="R"
                              onChange={(e) => setedttipoacesso(e.target.value)}
                              checked={edttipoacesso === "R"}
                            />
                            <label className="form-check-label">RH</label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoacesso"
                              value="G"
                              onChange={(e) => setedttipoacesso(e.target.value)}
                              checked={edttipoacesso === "G"}
                            />
                            <label className="form-check-label">Gestor</label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="tipoacesso"
                              value="P"
                              onChange={(e) => setedttipoacesso(e.target.value)}
                              checked={edttipoacesso === "P"}
                            />
                            <label className="form-check-label">Proprietário</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-10">
                        <br />
                        <input type="file" onChange={handleFileUpload} />
                        <p>Link da Foto: <a href={edtfoto} target="_blank" rel="noopener noreferrer">{edtfoto}</a></p>
                      </div>
                    </div>

                    <div>
                      <button disabled={novo} type="button" className="btn btn-primary me-4" onClick={ListarAviso}>
                        Aviso
                      </button>
                      <button disabled={novo} type="button" className="btn btn-primary me-4" onClick={ListarBloqueio}>
                        Bloqueio
                      </button>
                      <button disabled={novo} type="button" className="btn btn-primary" onClick={ListarMochila}>
                        Mochila
                      </button>
                    </div>
                  </form>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button type="button" className="btn btn-success" onClick={Salvar}>
                    Salvar
                  </button>

                </div>
              </div>
            </Modal>

            <ModalAviso
              isOpen={showformaviso}
              onRequestClose={closeModalAviso}
              overlayClassName="modal-overlay"
              className="modal-content modal-xl"
            >
              <div className="container-fluid h-100">
                <div className="modal-header">
                  <h2>Avisos do profissional: {edtnome}</h2>
                  <button type="button" className="btn-close" onClick={closeModalAviso}></button>
                </div>

                <div className="modal-body">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-6">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-2">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarAviso}>
                          Adicionar
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Descrição</th>
                            <th>Dt. Visualizado</th>
                            <th className="acao">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listaaviso.map(function (item) {
                            return (
                              <tr key={item.codaviso}>
                                <th>{item.codaviso}</th>
                                <th>{item.descricao}</th>
                                <th>{FormataDataHora(item.dtvisualizado)}</th>
                                <th>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn fa-solid fa-trash"
                                      type="button"
                                      onClick={() => handleOpenAviso(item)}
                                    ></button>
                                  </div>
                                </th>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan={4}>Quantidade de Registros: {listaaviso.length}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </form>
                </div>

                <div className="modal-footer">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalAviso}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalAviso>

            <ModalBloqueio
              isOpen={showformbloqueio}
              onRequestClose={closeModalBloqueio}
              overlayClassName="modal-overlay"
              className="modal-content modal-xl"
            >
              <div className="container-fluid h-100">
                <div className="modal-header">
                  <h2>Bloqueios do profissional: {edtnome}</h2>
                  <button type="button" className="btn-close" onClick={closeModalBloqueio}></button>
                </div>


                <div className="modal-body">
                  <form>
                    <div className="row col-sm-12">
                      <div className="col-sm-4">
                        <label htmlFor="dtlancamento" className="form-label">
                          Dt. Lançamento
                        </label>
                        <input
                          type="datetime-local"
                          id="dtlancamento"
                          className="form-control"
                          placeholder="Dt. Lançamento"
                          value={edtdtlancamento}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="row col-sm-12">
                      <div className="col-sm-6">
                        <label htmlFor="motivo" className="form-label">
                          Motivo
                        </label>
                        <input
                          type="text"
                          id="motivo"
                          className="form-control"
                          placeholder="Motivo"
                          value={edtmotivo}
                          onChange={(e) => setedtmotivo(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <label htmlFor="dtvencimento" className="form-label">
                          Dt. Vencimento
                        </label>
                        <input
                          type="datetime-local"
                          id="dtvencimento"
                          className="form-control"
                          placeholder="Dt. Vencimento"
                          value={edtsenha}
                          onChange={(e) => setedtsenha(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-3">
                        <br />
                        <button type="button" className="btn btn-primary" onClick={CadastrarBloqueio}>
                          Adicionar
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Dt. Lançamento</th>
                            <th>Motivo</th>
                            <th>Dt. Vencimento</th>
                            <th className="acao">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listabloqueio.map(function (item) {
                            return (
                              <tr key={item.codbloqueio}>
                                <th>{item.codbloqueio}</th>
                                <th>{FormataDataHora(item.dtlancamento)}</th>
                                <th>{item.motivo}</th>
                                <th>{FormataDataHora(item.dtvencimento)}</th>
                                <th>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      type="button"
                                      className="btn fa-solid fa-trash"
                                      onClick={() => handleOpenBloqueio(item)}
                                    ></button>
                                  </div>
                                </th>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan={5}>Quantidade de Registros: {listabloqueio.length}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </form>
                </div>

                <div className="modal-footer">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button type="button" className="btn btn-danger ms-4" onClick={closeModalBloqueio}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </ModalBloqueio>

            <ModalMochila
              isOpen={showformmochila}
              onRequestClose={closeModalMochila}
              className="modal-lg"
              overlayClassName="modal-overlay"
              contentLabel="Mochila de Itens"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Mochila de Itens</h5>
                  <button type="button" className="btn-close" onClick={closeModalMochila}></button>
                </div>
                <div className="modal-body">
                  {/* Totalizadores */}
                  <div className="d-flex justify-content-between p-2 bg-dark text-white rounded mb-3">
                    <div className="d-flex align-items-center">
                      <i className="fas fa-coins me-2"></i> <span>Total Coins: </span> {SaldoCoin}
                    </div>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-dollar-sign me-2"></i> <span>Total Real: </span> R$ {SaldoReal}
                    </div>
                  </div>

                  {/* Tabela de Cards */}
                  <div className="d-grid gap-2 product-grid">
                    {listaitens.map((product, index) => (
                      <div className="card text-center bg-secondary text-white product-card" key={index}>
                        <img src={product.foto} className="card-img-top" alt={product.description} />
                        <div className="card-body">
                          <h6 className="card-title">{product.descricao}</h6>
                          <p className="card-text">Qtd: {product.qtde}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Lista de Benefícios */}
                  <div className="mt-4 p-3 bg-dark text-white rounded">
                    <h6><i className="fas fa-gift me-2"></i> Benefícios</h6>
                    <ul className="mb-0">
                      {listabeneficio.map((benefit, index) => (
                        <li key={index}>{benefit.descricao}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeModalMochila}>
                    Fechar
                  </button>
                </div>
              </div>
            </ModalMochila>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de Profissionais</h1>
            <p className="ms-4">Rotina para cadastrar os profissionais da empresa</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código, nome, setor ou função"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Setor</th>
                  <th>Função</th>
                  <th>Usuário</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codcolaborador}>
                      <th>{item.codcolaborador}</th>
                      <th>{item.nome}</th>
                      <th>{item.setor}</th>
                      <th>{item.funcao}</th>
                      <th>{item.usuario}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={6}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadColaborador;
